import can1 from "../assets/canopener/can1.png";
import petpal from "../assets/petpal/petpal.png";
import robot from "../assets/robot/robot.png";
import order from "../assets/foodordering/order.png";
import cnc from "../assets/cnc/cnc.png";
import screwdriver from "../assets/screwdriver.png";
import gearbox from "../assets/gearbox/transparent.png";
import capstone from "../assets/silage/silage_home.png";
import acc from "../assets/acc/3dprint.png";
import breakout from "../assets/breakout.png";
import reversi from "../assets/reversi.png";
import dinat from "../assets/dinat/dinat.png";
import material from "../assets/material.png";
import psu from "../assets/psu2.png";
import smartparking from "../assets/parkinglot/parkinglot.png";
import speechemotion from "../assets/speech/audio2.png";
import recipe from "../assets/recipe.png";

const projects = [
  {
    id: "smartparking",
    title: "Smart Parking Lot System",
    description:
      "Embedded C++ system on Raspberry Pi Pico with real-time IR-based car detection, LED spot indicators, and a shortest-path algorithm that actively guides drivers to open spots.",
    imageUrl: smartparking,
    details: "Detailed information about the project TBD soon...",
    category: "Hardware",
    status: "Completed",
    tags: ["C++", "Embedded Systems", "IoT"],
  },
  {
    id: "silage",
    title: "Bluetooth Silage Measurement Device",
    description:
      "End-to-end capstone project: handheld BLE moisture meter for silage quality monitoring. Spans multi-sensor fusion, BLE firmware, custom PCB design, and a Flutter companion app for live data visualization.",
    imageUrl: capstone,
    details: "Detailed information about the project TBD soon...",
    category: "Hardware",
    status: "Completed",
    tags: ["Bluetooth", "Flutter", "PCB Design"],
  },
  {
    id: "accsystem",
    title: "Adaptive Cruise Control System",
    description:
      "Autonomous driving platform on Raspberry Pi 5 combining YOLO-based computer vision with a closed-loop PID controller for real-time adaptive cruise control, lane tracking, and traffic sign recognition.",
    imageUrl: acc,
    details: "Detailed information about the project TBD soon...",
    category: "Hardware",
    status: "Completed",
    tags: ["Python", "YOLO", "PID Control", "Computer Vision"],
  },
  {
    id: "speechemotion",
    title: "Real-Time Speech Emotion Recognition",
    description:
      "Streaming emotion classifier on live microphone input — CNN–LSTM model with MFCC feature extraction, sliding-window inference, and noise augmentation for robust telephony-quality performance.",
    imageUrl: speechemotion,
    category: "Software",
    status: "Completed",
    tags: ["Python", "CNN-LSTM", "MFCC", "Audio Processing"],
  },
  {
    id: "gearbox",
    title: "Optimized Two-Stage Speed Reducer",
    description:
      "Full mechanical design of a two-stage helical gear reducer (30 hp, 1875 → 97 rpm). Covers gear and bearing selection, GD&T drawings, tolerance stack-up, FEA stress analysis, and DFM/DFA review.",
    imageUrl: gearbox,
    details: "Detailed information about the project TBD soon...",
    category: "Hardware",
    status: "Completed",
    tags: ["SolidWorks", "FEA", "GD&T", "DFM/DFA"],
  },
  {
    id: "psu",
    title: "Adaptive DC Power Supply",
    description:
      "Designed and prototyped an adjustable DC lab power supply with current limiting and over-voltage protection — includes PSPICE simulation, component selection, and a custom PCB layout.",
    imageUrl: psu,
    details:
      "• Designed and prototyped custom PCB circuits for an adjustable DC lab power supply with current limiting and voltage regulation, applying PSPICE simulations and professional PCB layout techniques.",
    category: "Hardware",
    status: "Completed",
    tags: ["PCB Design", "Power Electronics", "PSPICE"],
  },
  {
    id: "dinat",
    title: "Pneumothorax Detection in Chest X-Rays",
    description:
      "Fine-tuned a DiNAT vision transformer for medical X-ray segmentation, detecting pneumothorax regions with ~80% accuracy and 68.5% mIoU. Covers data preprocessing, model training, and evaluation.",
    imageUrl: dinat,
    details: "",
    category: "Software",
    status: "Completed",
    tags: ["Python", "DiNAT", "U-Net", "Medical Imaging", "Machine Learning"],
  },
  {
    id: "canopener",
    title: "Mechanical Can Opener Redesign",
    description:
      "Redesigned a hand can opener in SolidWorks to improve ergonomics and durability — full DFM analysis, iterative prototyping, and comparative user evaluation to validate the design improvements.",
    imageUrl: can1,
    details: "Detailed information about the project TBD soon...",
    category: "Hardware",
    status: "Completed",
    tags: ["SolidWorks", "DFM", "Ergonomics"],
  },
  {
    id: "screwdriver",
    title: "Mechanical Screwdriver Redesign",
    description:
      "Redesigned a ratcheting screwdriver mechanism in SolidWorks, optimizing the torque path and leverage geometry to reduce user effort while improving manufacturability.",
    imageUrl: screwdriver,
    details: "Detailed information about the project TBD soon...",
    category: "Hardware",
    status: "Completed",
    tags: ["SolidWorks", "Mechanism Design", "DFM"],
  },
  {
    id: "cnc",
    title: "CNC Pick and Place Machine",
    description:
      "Designed a CNC pick-and-place machine in SolidWorks for automated PCB component placement — covers axis kinematics, drive selection, fixture design, and control system integration for high-repeatability operation.",
    imageUrl: cnc,
    details: "Detailed information about the project TBD soon...",
    category: "Hardware",
    status: "Completed",
    tags: ["SolidWorks", "CNC", "Automation", "Kinematics"],
  },
  // Software / UX Projects
  {
    id: "recipe",
    title: "Recipe App",
    description:
      "UX design project for a recipe management app — user research, competitive analysis, wireframing, and high-fidelity Figma prototyping with a focus on intuitive ingredient management and personalized discovery.",
    imageUrl: recipe,
    details: "Detailed information about the project TBD soon...",
    category: ["UX Design", "Software"],
    status: "In Progress",
    tags: ["Figma", "UX Design", "User Research", "Prototyping"],
  },
  {
    id: "material",
    title: "ML Material Recommendation System",
    description:
      "ML system that recommends suitable engineering materials from user-specified performance constraints — MLP model trained on material property datasets, with data preprocessing and accuracy benchmarking.",
    imageUrl: material,
    details: "Detailed information about the project TBD soon...",
    category: "Software",
    status: "Completed",
    tags: ["Python", "MLP", "Machine Learning", "Data Science", "R"],
  },
  {
    id: "robot",
    title: "Compact Underwater Explorer Robot",
    description:
      "Mechanical design of a compact modular underwater robot — buoyancy control system, watertight housing, and a swappable payload bay for interchangeable sensor and camera modules.",
    imageUrl: robot,
    details: "Detailed information about the project TBD soon...",
    category: "Hardware",
    status: "Completed",
    tags: ["SolidWorks", "Mechanical Design"],
  },
  {
    id: "breakout",
    title: "Breakout Game",
    description:
      "Classic Breakout game built entirely in MIPS Assembly — low-level graphics rendering, real-time keyboard input, and a full game loop with no OS or library support.",
    imageUrl: breakout,
    details: "Detailed information about the project TBD soon...",
    category: "Software",
    status: "Completed",
    tags: ["Assembly", "Low-Level Programming"],
  },
  {
    id: "reversi",
    title: "Reversi AI Game",
    description:
      "Reversi (Othello) in C++ with an AI opponent powered by alpha-beta pruning minimax search and heuristic board evaluation for strong mid-game play.",
    imageUrl: reversi,
    details: "Detailed information about the project TBD soon...",
    category: "Software",
    status: "Completed",
    tags: ["C++", "AI", "Alpha-Beta Pruning"],
  },
  {
    id: "petpal",
    title: "Petpal — Pet Adoption Platform",
    description:
      "Full-stack pet adoption platform built with React and Django — shelter listings, adoption applications, and a UX-research-driven interface designed for both seekers and shelters.",
    imageUrl: petpal,
    details: "Detailed information about the project TBD soon...",
    category: ["UX Design", "Software"],
    status: "Completed",
    tags: ["React", "Django", "REST API", "UX Design"],
  },
  {
    id: "onlineorder",
    title: "Cafe to Desk Delivery System",
    description:
      "Full-stack cafe ordering system with real-time order tracking, a staff management dashboard, and role-based views for customers and operators — built with React, Express.js, and MongoDB.",
    imageUrl: order,
    details: "Detailed information about the project TBD soon...",
    category: ["UX Design", "Software"],
    status: "Completed",
    tags: ["React", "Express.js", "MongoDB", "UX Design"],
  },
];

export default projects;
